import { create } from 'zustand';

const useKVKKCompanyStore = create((set, get) => ({
  companyData: null,
  users: [],
  loading: false,
  saving: false,
  error: null,

  setLoading: (loading) => set({ loading }),
  setSaving: (saving) => set({ saving }),
  setError: (error) => set({ error }),
  setCompanyData: (data) => set({ companyData: data }),
  setUsers: (users) => set({ users }),

  resetForm: () => {
    set({
      companyData: null,
      error: null,
      loading: false,
      saving: false
    });
  },

  getUsersForMultiSelect: (revealNames = false) => {
    const { users } = get();
    return users.map(user => {
      const id = user._id?.$oid || user._id || user.id || '';
      const rawName = `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.username || user.email;
      let label = rawName;
      if (!revealNames && rawName) {
        label = rawName
          .split(/\s+/)
          .filter(Boolean)
          .map((part) => (part.length <= 1 ? '*' : `${part[0]}${'*'.repeat(Math.min(part.length - 1, 5))}`))
          .join(' ');
      }
      return {
        value: id.toString(),
        label,
      };
    });
  },

  getCountryOptions: () => [
    { value: 'TR', label: 'Turkey' },
    { value: 'US', label: 'United States' },
    { value: 'GB', label: 'United Kingdom' },
    { value: 'DE', label: 'Almanya' },
    { value: 'FR', label: 'Fransa' },
    { value: 'IT', label: 'Italy' },
  ]
}));

export const useKvkkCompanyStore = useKVKKCompanyStore;
export default useKVKKCompanyStore;
